import React from 'react'
import { CFooter } from '@coreui/react'
import { t } from 'i18next'

const Footer = () => {
  return (
    <CFooter className="mt-5 px-4 d-flex justify-content-center">
      <div>
        <span>Copyright © {new Date().getFullYear()} {t('text.copyright_sterz')}</span>
      </div>
    </CFooter>
  )
}

export default React.memo(Footer)
